import * as React from 'react'
import {
  useEditBusinessTripStore,
  selectIsAnyExtraContentOpen,
} from '@/modules/drivers/stores/editBusinessTripStore'

export { selectIsAnyExtraContentOpen }

export const useEditBusinessTrip = () => {
  const store = useEditBusinessTripStore()
  return {
    ...store,
    refreshData: store.refresh,
    isAnyExtraContentOpen: selectIsAnyExtraContentOpen(store),
  }
}

// Kept for callers that render <EditBusinessTripProvider> — now a no-op.
// The setRefreshKey prop is replaced by useEditBusinessTripStore(s => s.refreshKey).
export const EditBusinessTripProvider: React.FC<{
  children: React.ReactNode
  setRefreshKey?: any
}> = ({ children }) => {
  const reset = useEditBusinessTripStore((s) => s.reset)
  React.useEffect(() => () => { reset() }, [])
  return <>{children}</>
}
